module.exports = __webpack_public_path__ + "img/error-alert.1b054213.svg";